<template>
  <div class="slide">
    <iframe width="100%" scrolling="no" height="100%" src="https://maphub.net/embed_h/WQO7iVOpkSp6U3lr?autoplay=1"
      frameborder="0"></iframe>
    <div class="sidepanels" v-if="active">
      <div class="panelc p is-hidden-mobile">
        <i>Lékárna u Polikliniky</i>
        <p>Husova 73<br>506 01 Jičín</p>
        <br>
        <div class="columns is-variable is-mobile is-multiline is-1">
          <div class="column is-2">
            <b-icon icon="phone" type="is-primary"></b-icon>
          </div>
          <div class="column  is-10 has-text-weight-bold">
            <a class="has-text-black" href="tel: +420491202212">491 202 212</a>
          </div>
          <div class="column is-2">
            <b-icon icon="cellphone" type="is-primary"></b-icon>
          </div>
          <div class="column  is-10 has-text-weight-bold">
            <a class="has-text-black" href="tel: +420702272811">702 272 811</a>
          </div>
          <div class="column  is-2">
            <b-icon icon="mail" type="is-primary"></b-icon>
          </div>
          <div class="column is-10 ">
            <a class="has-text-black" href="mailo: lekarna.jc-hus@seznam.cz">lekarna.jc-hus@seznam.cz</a>
          </div>
        </div>
        <div class="tagline b">
          PROVOZOVNA
        </div>
      </div>
      <div class="panelc o is-hidden-mobile">
        <span class="has-text-white has-background-dark p">&nbsp;&nbsp;Otevírací doba&nbsp;&nbsp;</span>
        <table>
          <tbody>
            <tr>
              <td class="headinger">PO:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ÚT:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ST:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ČT:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">PÁ:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
          </tbody>
        </table>
        <span class="has-text-dark has-background-light c r1">V e-shopu jsme dispozici</span><br><span class="has-text-dark has-background-light c r2">každý den od 8-15h</span>
      </div>
      <div class="panelc f is-hidden-mobile">
        <div class="tagline t">
          FAKTURACE
        </div>
        <i>Lékárna Český ráj s.r.o.</i>
        <p>Husova 393<br>
          50601 Jičín</p>
        <br>
        IČ: <b>28856406</b><br>
        DIČ: <b>CZ28856406</b>
      </div>
      <div class="panelm is-hidden-tablet">
        <div class="columns is-mobile">
          <div class="column is-half">
            <b>Provozovna</b><br>
            <i>Lékárna u Polikliniky</i>
            <p>Husova 73<br>506 01 Jičín</p>
          </div>
          <div class="column is-half">
            <b>Fakturace</b><br>
            <i>Lékárna Český ráj s.r.o.</i>
            <p>Husova 393<br>
              50601 Jičín</p>
          </div>
          
        </div>
        <br>
        <div class="columns is-variable is-mobile is-multiline is-1">
          <div class="column is-2">
            <b-icon icon="phone" type="is-primary"></b-icon>
          </div>
          <div class="column  is-10 has-text-weight-bold">
            <a class="has-text-black" href="tel: +420491202212">491 202 212</a>
          </div>
          <div class="column is-2">
            <b-icon icon="cellphone" type="is-primary"></b-icon>
          </div>
          <div class="column  is-10 has-text-weight-bold">
            <a class="has-text-black" href="tel: +420702272811">702 272 811</a>
          </div>
          <div class="column  is-2">
            <b-icon icon="mail" type="is-primary"></b-icon>
          </div>
          <div class="column is-10 ">
            <a class="has-text-black" href="mailo: lekarna.jc-hus@seznam.cz">lekarna.jc-hus@seznam.cz</a>
          </div>
        </div>
        <br>
        <div class="has-text-white has-background-dark p fw">&nbsp;&nbsp;Otevírací doba&nbsp;&nbsp;</div>
        <br>
        <table>
          <tbody>
            <tr>
              <td class="headinger">PO:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ÚT:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ST:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">ČT:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
            <tr>
              <td class="headinger">PÁ:</td>
              <td></td>
              <td>7:30</td>
              <td class="central">–</td>
              <td>17:00</td>
            </tr>
          </tbody>
        </table>
        <div class="has-text-dark has-background-light c r1 fw">V e-shopu jsme dispozici každý den od 8-15h</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContactPage',
    props: {
      active: Boolean
    }
  }
</script>
<style scoped>
.slide {
    position: relative;
  }
.headinger {
  font-weight: bold;
  padding-right: 20px;
}
.central {
  padding-left: 20px;
  padding-right: 20px;
}
  .column {
    padding: 5px;
  }

  iframe {
    pointer-events: none;
  }
.p {
  padding: 5px;
  border-radius: 5px;
}
.c {
  padding: 5px;
  
}
.r1 {
  border-radius: 5px;
}
.r2 {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
table {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content:center
}
  .sidepanels {
    z-index: 9002;
    position: absolute;
    top: 0;
    height: 100%;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 150px;
  }
.fw {
  width: calc(100%);
  text-align: center
}
  .panelc.f {
    -webkit-box-shadow: 0px 0px 45px -12px #11A6C2;
    -moz-box-shadow: 0px 0px 45px -12px #11A6C2;
    box-shadow: 0px 0px 45px -12px #11A6C2;
    padding-top: 35px;
    animation-delay: 700ms;
  }
  .panelc.o {
    -webkit-box-shadow: 0px 0px 45px -12px rgb(83, 134, 141);
    -moz-box-shadow: 0px 0px 45px -12px rgb(83, 134, 141);
    box-shadow: 0px 0px 45px -12px rgb(83, 134, 141);
    animation-delay: 500ms;
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: center
  }
  .panelc.p {
    -webkit-box-shadow: 0px 0px 45px -12px #000000;
    -moz-box-shadow: 0px 0px 45px -12px #000000;
    box-shadow: 0px 0px 45px -12px #000000;
    animation-delay: 300ms;
  }

  .panelc {
    padding: 30px;
    padding-top: 25px;
    padding-bottom: 25px;
    border-radius: 35px;
    background-color: white;
    width: 350px;
    margin-top: 40px;
    margin-bottom: 40px;
    -webkit-animation: flip-in-hor-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: flip-in-hor-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    position: relative;
  }

  .panelm {
    padding: 50px;
    padding-top: 25px;
    padding-bottom: 25px;
    border-radius: 0px;
    background-color: white;
    width: 100%;
    height: calc(100% - 45px);
    -webkit-animation: flip-in-hor-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: flip-in-hor-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    position: relative;
    border-radius: 5px;
  }

  .tagline {
    position: absolute;
    display: flex;

    -webkit-box-shadow: inset 0px 0px 25px -9px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: inset 0px 0px 25px -9px rgba(0, 0, 0, 0.25);
    box-shadow: inset 0px 0px 25px -9px rgba(0, 0, 0, 0.25);
    font-weight: bold;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 10px;
    width: 150px;
    left: calc(50% - calc(150px / 2));
    justify-content: center;
  }

  .tagline.t {
    background: #11A6C2;
    color: white;
    top: -17px;
  }

  .tagline.b {
    color: #11A6C2;
    bottom: -17px;
    background: #252525;
  }
    @media screen and (max-height: 768px) { 
    .sidepanels {
        flex-direction: row;
        align-items: center;
      }
      .panelc {
        height: 300px;
        margin: 10px;
      }
            .tagline.b {
              color: #11A6C2;
              top: -17px;
              bottom: unset;
              background: #252525;
            }
    }
  @media screen and (max-width: 768px) {
    .sidepanels {
      margin: 20px;
      display: block;
      width: calc(100% - 40px);
      flex-direction: row;
    }

    .panelc {
      width: 100%;
      margin-top: 0px;
      border-radius: 0px;
      margin-bottom: 40px;
    }

    iframe {
      filter: blur(5px);
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-10-9 14:5:55
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation flip-in-hor-bottom
 * ----------------------------------------
 */
  @-webkit-keyframes flip-in-hor-bottom {
    0% {
      -webkit-transform: rotateX(80deg);
      transform: rotateX(80deg);
      opacity: 0;
    }

    100% {
      -webkit-transform: rotateX(0);
      transform: rotateX(0);
      opacity: 1;
    }
  }

  @keyframes flip-in-hor-bottom {
    0% {
      -webkit-transform: rotateX(80deg);
      transform: rotateX(80deg);
      opacity: 0;
    }

    100% {
      -webkit-transform: rotateX(0);
      transform: rotateX(0);
      opacity: 1;
    }
  }
</style>